module.exports = __webpack_public_path__ + "img/comp-firefly.e934f49e.svg";